import "pixi";
import "phaser";

import { Game } from "./Game";
    
window.onload = () => {

    const game = new Game();
};
